export default __webpack_public_path__ + "static/media/quad_top.571072b3.svg";